// @ts-nocheck
import React from "react";
import { Outlet } from "react-router-dom";
import { AppShell } from "@/components/shell/AppShell";
import { orgAdminNav, orgAdminFooterNav } from "@/config/orgAdminNav";
import AreaUserMenu from "@/components/common/AreaUserMenu";
import { MyOrganizationsProvider } from "@/contexts/MyOrganizationsContext";
import OrgSwitcher from "@/components/shell/OrgSwitcher";
import { useModules } from "@/hooks/useModules";
import { filterNavByModules } from "@/lib/navModules";
import { useEventNav } from "@/hooks/useEventNav";
import EventNavHeader from "@/components/shell/EventNavHeader";



/**
 * Layout for ORG ADMIN users. Reuses the shared AppShell and the same admin
 * dashboard routes, but with the reduced org-admin nav and an org switcher
 * (logo/name + dropdown) resolved from the user's organization_members rows.
 */
const OrgAdminDashboardLayout: React.FC = () => {
  const { isEnabled } = useModules();
  const eventNav = useEventNav(isEnabled);
  const navGroups = React.useMemo(
    () => (eventNav ? eventNav.groups : filterNavByModules(orgAdminNav, isEnabled)),
    [eventNav, isEnabled]
  );
  return (
    <MyOrganizationsProvider>
      <AppShell
        navGroups={navGroups}
        footerNav={eventNav ? undefined : orgAdminFooterNav}
        navHeader={
          eventNav ? (
            <EventNavHeader
              name={eventNav.name}
              startDate={eventNav.startDate}
              endDate={eventNav.endDate}
              status={eventNav.status}
            schedulePublished={eventNav.schedulePublished}
            />
          ) : undefined
        }
        brand={<OrgSwitcher />}

        userMenu={
          <AreaUserMenu roleLabel="Org Admin" settingsPath="/admin-dashboard/settings" />
        }
      >
        <div data-page-pad className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </AppShell>
    </MyOrganizationsProvider>
  );
};

export default OrgAdminDashboardLayout;
